import React from 'react'
import { Link } from 'react-router-dom'

function AddPropertiesPage() {
    return (
        <>
            <section className="flat-title2 ">
                <div className="container7">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-inner style">
                                <div className="title-group fs-18 fw-7">
                                    <Link className="home fw-6 text-color-3" to="/dashboard/properties">
                                        Biens immobiliers
                                    </Link>
                                    <span>Ajouter une propriété</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="flat-upload-photo">
                <div className="container7">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="tf-upload">
                                <h3 className="titles">Attacher des photos</h3>
                                <div className="wrap-upload center">
                                    <div className="box-upload">
                                        <div className="img-up relative">
                                            <img
                                                className="avatar"
                                                id="profileimg"
                                                src="/assets/images/icon/icon-upload.png"
                                                alt=""
                                            />
                                        </div>
                                        <div className="button-box relative" id="upload-profile">
                                            <a href="#" className="btn-upload sc-button">
                                                <span>Sélectionner des photos</span>{" "}
                                            </a>
                                            <input
                                                id="tf-upload-img"
                                                type="file"
                                                name="profile"
                                                required=""
                                            />
                                        </div>
                                        <div className="text-up-box">
                                            <p className="text-color-2">ou faites glisser les photos ici</p>
                                            <p> (Jusqu'à 10 photos)</p>
                                        </div>
                                    </div>
                                    <div className="box-photo">
                                        <ul className="flex">
                                            <li className="file-delete">
                                                <img
                                                    src="/assets/images/img-box/dashboard-upload-1.jpg"
                                                    alt=""
                                                />
                                                <a className="icon-clear remove-file">
                                                    <i className="far fa-trash-alt" />
                                                </a>{" "}
                                            </li>
                                            <li className="file-delete">
                                                <img
                                                    src="/assets/images/img-box/dashboard-upload-2.jpg"
                                                    alt=""
                                                />
                                                <a className="icon-clear remove-file">
                                                    <i className="far fa-trash-alt" />
                                                </a>{" "}
                                            </li>
                                            <li className="file-delete">
                                                <img
                                                    src="/assets/images/img-box/dashboard-upload-3.jpg"
                                                    alt=""
                                                />
                                                <a className="icon-clear remove-file">
                                                    <i className="far fa-trash-alt" />
                                                </a>{" "}
                                            </li>
                                            <li className="file-delete">
                                                <img
                                                    src="/assets/images/img-box/dashboard-upload-4.jpg"
                                                    alt=""
                                                />
                                                <a className="icon-clear remove-file">
                                                    <i className="far fa-trash-alt" />
                                                </a>{" "}
                                            </li>
                                            <li className="file-delete">
                                                <img
                                                    src="/assets/images/img-box/dashboard-upload-5.jpg"
                                                    alt=""
                                                />
                                                <a className="icon-clear remove-file">
                                                    <i className="far fa-trash-alt" />
                                                </a>{" "}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                            <div className="tf-infomation bg-white">
                                <h3 className="titles">Informations</h3>
                                <div className="info-box info-wg">
                                    <div className="inner-1 select-group">
                                        <label className="title-user fw-6">Adresse *</label>
                                        <div className="nice-select" tabIndex={0}>
                                            <span className="current">Choisir</span>
                                            <ul className="list">
                                                <li data-value="" className="option selected">
                                                    Choisir
                                                </li>
                                                <li data-value="" className="option">
                                                    France
                                                </li>
                                                <li data-value="" className="option">
                                                    France
                                                </li>
                                                <li data-value="" className="option">
                                                    France
                                                </li>
                                                <li data-value="" className="option">
                                                    France
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="inner-2 form-wg flex">
                                        <div className="wg-box2 select-group">
                                            <fieldset>
                                                <label className="title-user fw-6">Numéro d'unité *</label>
                                                <input
                                                    type="tel"
                                                    placeholder=" "
                                                    className="input-form"
                                                    required=""
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="wg-box2 select-group">
                                            <fieldset>
                                                <label className="title-user fw-6">Code postal *</label>
                                                <input
                                                    type="text"
                                                    placeholder=" "
                                                    className="input-form"
                                                    required=""
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="wg-box2 select-group">
                                            <label className="title-user fw-6">État</label>
                                            <div className="nice-select" tabIndex={0}>
                                                <span className="current">Choisir</span>
                                                <ul className="list">
                                                    <li data-value="" className="option selected">
                                                        Choisir
                                                    </li>
                                                    <li data-value="like" className="option">
                                                        Neuf
                                                    </li>
                                                    <li data-value="love" className="option">
                                                        En bon état
                                                    </li>
                                                    <li data-value="care" className="option">
                                                        Besoin de réparations
                                                    </li>
                                                    <li data-value="feel" className="option">
                                                        En construction
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="tf-price tf-infomation bg-white">
                                <h3 className="titles">Prix &amp; Durée</h3>
                                <div className="info-box info-wg">
                                    <div className="inner-1 form-wg flex">
                                        <div className="wg-box">
                                            <label className="title-user fw-6">Coûts de location *</label>
                                            <div className="nice-select" tabIndex={0}>
                                                <span className="current font-2 fw-7">$ 750.00</span>
                                                <span className="month">Par mois</span>
                                                <ul className="list style">
                                                    <li data-value={500} className="option">
                                                        $ 500.00
                                                    </li>
                                                    <li data-value={750} className="option selected">
                                                        $ 750.00
                                                    </li>
                                                    <li data-value={1000} className="option">
                                                        $ 1000.00
                                                    </li>
                                                    <li data-value={2000} className="option">
                                                        $ 2000.00
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="wg-box">
                                            <label className="title-user fw-6">
                                                Frais de retard (Optionnel)
                                            </label>
                                            <div className="nice-select" tabIndex={0}>
                                                <span className="current font-2 fw-7">$ 56.00</span>
                                                <span className="month">Par 3 mois</span>
                                                <ul className="list style">
                                                    <li data-value={20} className="option">
                                                        $ 20.00
                                                    </li>
                                                    <li data-value={56} className="option selected">
                                                        $ 56.00
                                                    </li>
                                                    <li data-value={100} className="option">
                                                        $ 100.00
                                                    </li>
                                                    <li data-value={200} className="option">
                                                        $ 200.00
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inner-2 form-wg flex">
                                        <div className="wg-box">
                                            <label className="title-user fw-6">
                                                Accompte minimum (Optionnel)
                                            </label>
                                            <div className="nice-select" tabIndex={0}>
                                                <span className="current font-2 fw-7">$ 56.00</span>
                                                <span className="month">Par 3 mois</span>
                                                <ul className="list style">
                                                    <li data-value={20} className="option">
                                                        $ 20.00
                                                    </li>
                                                    <li data-value={56} className="option selected">
                                                        $ 56.00
                                                    </li>
                                                    <li data-value={100} className="option">
                                                        $ 100.00
                                                    </li>
                                                    <li data-value={200} className="option">
                                                        $ 200.00
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="wg-box">
                                            <label className="title-user fw-6">
                                                Durée minimale de location *
                                            </label>
                                            <div className="box-quantity flex align-center">
                                                <div className="title-sub fs-13">
                                                    <span className="fw-7">Durée minimale</span>
                                                    <span> (en mois)</span>
                                                </div>
                                                <div className="quantity flex align-center">
                                                    <a className="btn-quantity plus-btn">
                                                        <i className="far fa-plus" />
                                                    </a>
                                                    <div className="input-text">
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            defaultValue={1}
                                                            className="quantity-number"
                                                        />
                                                    </div>
                                                    <a className="btn-quantity minus-btn">
                                                        <i className="far fa-minus" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="tf-rent tf-infomation bg-white">
                                <h3 className="titles">Informations supplémentaires</h3>
                                <div className="info-box info-wg">
                                    <div className="inner-1 form-wg flex">
                                        <div className="wg-box2 select-group">
                                            <label className="title-user fw-6">Statut</label>
                                            <div className="nice-select" tabIndex={0}>
                                                <span className="current">Choisir</span>
                                                <ul className="list style">
                                                    <li data-value="" className="option">
                                                        Choisir
                                                    </li>
                                                    <li data-value="Open" className="option">
                                                        Ouvert
                                                    </li>
                                                    <li data-value="Close" className="option selected">
                                                        Fermé
                                                    </li>
                                                    <li data-value="Repair" className="option">
                                                        Réparation
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inner-1 form-wg flex">
                                        <div className="wg-box2 select-group">
                                            <fieldset>
                                                <label className="title-user fw-6">Matériau</label>
                                                <input
                                                    type="text"
                                                    placeholder=" "
                                                    className="input-form"
                                                    required=""
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="wg-box2 select-group">
                                            <fieldset>
                                                <label className="title-user fw-6">Chambres</label>
                                                <input
                                                    type="text"
                                                    placeholder=" "
                                                    className="input-form"
                                                    required=""
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="wg-box2 select-group">
                                            <label className="title-user fw-6">Lits</label>
                                            <div className="nice-select" tabIndex={0}>
                                                <span className="current">Choisir</span>
                                                <ul className="list">
                                                    <li data-value="" className="option selected">
                                                        Lits
                                                    </li>
                                                    <li data-value="twin" className="option">
                                                        Lits jumeaux
                                                    </li>
                                                    <li data-value="bunk" className="option">
                                                        Lits superposés
                                                    </li>
                                                    <li data-value="kids" className="option">
                                                        Lits pour enfants
                                                    </li>
                                                    <li data-value="single" className="option">
                                                        Lit simple
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inner-1 form-wg flex">
                                        <div className="wg-box2 select-group">
                                            <label className="title-user fw-6">Bains</label>
                                            <div className="nice-select" tabIndex={0}>
                                                <span className="current">Choisir</span>
                                                <ul className="list">
                                                    <li data-value="" className="option selected">
                                                        Bains
                                                    </li>
                                                    <li data-value="floating" className="option">
                                                        Bains flottants
                                                    </li>
                                                    <li data-value="massage" className="option">
                                                        Bains de massage
                                                    </li>
                                                    <li data-value="floor-standing" className="option">
                                                        Bain sur pied
                                                    </li>
                                                    <li data-value="built-in" className="option">
                                                        Bains encastrés
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="wg-box2 select-group">
                                            <fieldset>
                                                <label className="title-user fw-6">Garages</label>
                                                <input
                                                    type="text"
                                                    placeholder=" "
                                                    className="input-form"
                                                    required=""
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="wg-box2 select-group">
                                            <label className="title-user fw-6">Année de construction</label>
                                            <div className="nice-select" tabIndex={0}>
                                                <span className="current">Choisir</span>
                                                <ul className="list">
                                                    <li data-value="" className="option">
                                                        Choisir
                                                    </li>
                                                    <li data-value={2010} className="option">
                                                        2010
                                                    </li>
                                                    <li data-value={2015} className="option">
                                                        2015
                                                    </li>
                                                    <li data-value={2020} className="option">
                                                        2020
                                                    </li>
                                                    <li data-value={2024} className="option">
                                                        2024
                                                    </li>
                                                    <li data-value={2022} className="option">
                                                        2022
                                                    </li>
                                                    <li data-value={2023} className="option">
                                                        2023
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inner-4 form-wg flex">
                                        <div className="wg-box2 select-group">
                                            <fieldset>
                                                <label className="title-user fw-6">Superficie habitable (m²)</label>
                                                <input
                                                    type="text"
                                                    placeholder=" "
                                                    className="input-form"
                                                    required=""
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="wg-box2 select-group">
                                            <fieldset>
                                                <label className="title-user fw-6">Dimensions du terrain</label>
                                                <input
                                                    type="text"
                                                    placeholder=" "
                                                    className="input-form"
                                                    required=""
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="wg-box2 select-group">
                                            <fieldset>
                                                <label className="title-user fw-6">Superficie du terrain (m²)</label>
                                                <input
                                                    type="text"
                                                    placeholder="ex : 20x20, 20x20x20"
                                                    className="input-form"
                                                    required=""
                                                />
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="tf-amenities bg-white">
                                <h3 className="titles">Équipements</h3>
                                <div className="wrap-amenities flex">
                                    <div className="box box-1 flex">
                                        <div className="inner-1">
                                            <div className="subtitle title-1 fw-6">Caractéristiques extérieures</div>
                                            <label className="flex">
                                                <input
                                                    name="newsletter"
                                                    type="checkbox"
                                                    defaultChecked=""
                                                />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Piscine</span>
                                            </label>
                                            <label className="flex">
                                                <input
                                                    name="newsletter"
                                                    type="checkbox"
                                                    defaultChecked=""
                                                />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Balcon</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Parking couvert</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Entièrement clôturé</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Spa extérieur</span>
                                            </label>
                                        </div>
                                        <div className="inner-2">
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Court de tennis</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Garage</span>
                                            </label>
                                            <label className="flex">
                                                <input
                                                    name="newsletter"
                                                    type="checkbox"
                                                    defaultChecked=""
                                                />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Espace extérieur</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Abri</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="box box-2 flex">
                                        <div className="inner-1">
                                            <div className="subtitle title-1 fw-6">Caractéristiques intérieures</div>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Suite parentale</span>
                                            </label>
                                            <label className="flex">
                                                <input
                                                    name="newsletter"
                                                    type="checkbox"
                                                    defaultChecked=""
                                                />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Bureau</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Système d'alarme</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Parquet</span>
                                            </label>
                                            <label className="flex">
                                                <input
                                                    name="newsletter"
                                                    type="checkbox"
                                                    defaultChecked=""
                                                />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Salle de jeux</span>
                                            </label>
                                        </div>
                                        <div className="inner-2">
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Lave-vaisselle</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Placards intégrés</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Internet haut débit</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Salle de sport</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Atelier</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="box box-3 flex">
                                        <div className="inner-1">
                                            <div className="subtitle title-1 fw-6">
                                                Contrôle climatique &amp; énergie
                                            </div>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Climatisation</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Chauffage</span>
                                            </label>
                                            <label className="flex">
                                                <input
                                                    name="newsletter"
                                                    type="checkbox"
                                                    defaultChecked=""
                                                />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Réservoir d'eau</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Panneaux solaires</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Eau chaude solaire</span>
                                            </label>
                                        </div>
                                        <div className="inner-2">
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Système de cuisson électrique</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Système de chauffage</span>
                                            </label>
                                            <label className="flex">
                                                <input name="newsletter" type="checkbox" />
                                                <span className="btn-checkbox" />
                                                <span className="fs-13">Filtre à poussière</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="tf-save">
                                <div className="wrap-button flex justify-center">
                                    <button className="sc-button" name="submit" type="submit">
                                        <span>Publier maintenant</span>
                                    </button>
                                    <button className="sc-button btn-1" name="submit" type="submit">
                                        <span>Enregistrer &amp; Prévisualiser</span>
                                    </button>
                                </div>
                            </div>

                            <div className="tf-bottom"></div>

                        </div>
                    </div>
                </div>
            </section></>
    )
}

export default AddPropertiesPage